<template>
	<div class="hero__cta">
		<div class="upper" v-if="text">
			<h1 v-html="text"></h1>
		</div>
		<div class="lower" v-if="link">
			<primary-button
				:link="JSON.parse(this.link)"
				:label="'Signs Inc.'"
			></primary-button>
		</div>
	</div>
</template>

<script>
import PrimaryButton from '../vue/PrimaryButton.vue';

export default {
	data() {
		return {};
	},

	props: {
		text: {},
		link: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {
		PrimaryButton,
	},

	created() {},
	destroyed() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.hero__cta {
	width: 100%;
	background: $signs-teal;
	z-index: 100;
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	column-gap: 0;
	row-gap: 100px;
	padding: 100px 0;

	@media (max-width: 1366px) {
		padding: 50px 0;
		row-gap: 50px;
	}

	.upper {
		grid-column: 2 / span 10;
		display: grid;
		grid-template-columns: repeat(10, 1fr);

		@media (max-width: 1366px) {
			grid-column: 2 / span 10;
		}

		h1 {
			font-size: 80px;
			color: white;
			grid-column: 1 / span 7;

			@media (max-width: 1366px) {
				font-size: 60px;
				line-height: 50px;
				grid-column: 1 / span 10;
				font-size: 40px;
			}
		}
	}

	.lower {
		grid-column: 2 / span 10;

		@media (max-width: 1366px) {
			grid-column: 2 / span 10;
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/HeroCta.vue